export const theme = {
  colors: {
    primary: '#0F62FE',
    primaryHover: '#0050E6',
    primaryActive: '#002D9C',
    secondary: '#f0f2f5',
    text: '#161616',
    textLight: '#6F6F6F',
    border: '#d9d9d9',
    borderInput: '#E0E0E0',
    borderInputFocus: '#0F62FE',
    error: '#DA1E28',
    success: '#24A148',
    warning: '#faad14',
    white: '#ffffff',
    background: '#ffffff',
    grayBackground: '#F4F4F4',
    cardDescription: '#525252',
    alert: {
      info: {
        bg: '#DDF4FF',
        border: '#4589FF',
      },
      warning: {
        bg: '#FFF8C5',
        border: '#FF832B',
      },
      error: {
        bg: '#FFEBE9',
        border: '#FA4D56',
      },
      success: {
        bg: '#DAFBE1',
        border: '#42BE65',
      },
    },
    button: {
      invisible: {
        active: '#E8E8E8',
      },
      danger: {
        default: '#DA1E28',
        hover: '#B81922',
        active: '#750E13',
      },
      dark: {
        default: '#393939',
        hover: '#474747',
        active: '#6F6F6F',
      },
    },
    subpartners: {
      selected: '#DAFBE1',
      hover: '#DDF4FF',
    },
    checkbox: {
      border: '#8D8D8D',
      focus: '#0050E6',
      checked: '#0F62FE',
    },
    link: '#0F62FE',
    divider: '#E0E0E0',
    tag: {
      accent: '#0F62FE',
      warning: '#FF832B',
      error: '#D1242F',
      created: '#4589FF',
      processed: '#0043CE',
      deleted: '#8D8D8D',
    },
    status: {
      active: '#42BE65',
    },
    radio: {
      border: '#525252',
    },
    progress: {
      fill: '#0F62FE',
      bg: '#C6C6C6',
    },
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  borderRadius: {
    sm: '4px',
    md: '6px',
    lg: '8px',
  },
  shadows: {
    sm: '0 1px 2px rgba(0, 0, 0, 0.04)',
    md: '0 2px 8px rgba(0, 0, 0, 0.06)',
    lg: '0 4px 12px rgba(0, 0, 0, 0.1)',
  },
  typography: {
    fontFamily: 'Inter, Roboto, sans-serif',
    sizes: {
      xs: '12px',
      sm: '14px',
      md: '16px',
      lg: '18px',
      xl: '20px',
      xxl: '24px',
    },
  },
}

export type Theme = typeof theme
